import { Rules } from '@/types/Rules';

const rules: Rules = {
  intro: {
    title: 'Willkommen in der Welt der Samurai',
    body: `<p>Im alten Japan spielst du um den Thron des Kaisers. Nur mit dem Bau von Palästen sicherst du deine Macht. Spielzug um Spielzug sammelst du das nötige Material dafür. </p>
    <p>
    Mit tapferen Samurai-Kriegern ziehst du gegen deine Kontrahenten in die Schlacht um deren Material zu plündern. Ein erfolgreicher Angriff hält so nicht nur den Palastbau des Gegners auf, sondern beschleunigt auch deinen eigenen.
    </p>
    
    <p>Nur wenn du deine Ressourcen geschickt kombinierst, strategisch handelst und mutig kämpfst, wirst du deinen dritten Palast errichten und als großer Kaiser in die Geschichte eingehen.</p>
    
    <h3>ATTACKE, HAI!!!</h3>

    <div class="col-12 col-sm-6 offset-sm-3 my-12">
      <a class="btn-icon"
          href="https://playtricto.com/downloads/tricto_samurai_regeln_DE.pdf"
          title="Die Regeln als PDF herunterladen" target="_blank"
          >
          <span class="btn-icon__icon btn-icon__icon--pdf" ></span> <span class="btn-icon__text">Regeln herunterladen</span>
      </a>
    </div>

    <div class="video-container" style="margin-top: 2rem">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/MOJ2IWsCKos" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  
    
    `,
  },
  areas: [
    // Preparation
    {
      title: 'Bevor es losgeht',
      classes: 'bg-beige',
      chapters: [
        {
          title: 'Ziel des Spiels',
          body: ` 
          <div class="row">
            <div class="col-12 col-sm-6">
 
              <h3>2, 3 oder 4 Spieler:</h3>
              <p>
              Wer zuerst <strong>3 Paläste</strong> baut, gewinnt das Spiel.
              </p>

              <div class="col-12 col-sm-8">
                <img src="/images/tricto-rules-game-end-a.jpg" class="image-responsive" />
              </div>

              <hr />

              <h3>5 oder 6 Spieler:</h3>
              <p>
                Hier reichen <strong>2 Paläste</strong> zum Gewinnen.
              </p>

              <div class="col-12 col-sm-8">
                <img src="/images/tricto-rules-game-end-b.jpg" class="image-responsive" />
              </div>
              
              
              </div>

            <div class="col-12 col-sm-6">
            <p>
              Um Paläste zu errichten, sammelst du Materialien aus den 3&nbsp;Rohstoffen: Reis,&nbsp;Erz&nbsp;und&nbsp;Bambus.
              </p>
              <p>
              Mit deinen Samurai kannst du 1&nbsp;Material von Gegnern erbeuten und deins verteidigen.
              </p>
              <p>
              Doch auch für die Ausbildung von Samurai brauchst du Rohstoffe …
              </p>

              <img src="/images/tricto-rules-game-fill-a.jpg" class="image-responsive" />

            </div>
          </div>
          
          `,
        },
        {
          title: 'Die 109 Karten',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Paläste</h4>
              <p>Wer zuerst seine 3 (bzw. 2) Paläste errichtet, hat das Spiel gewonnen.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-objectives.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Rohstoffe</h4>
              <p>Damit du einen Palast bauen kannst, musst du von jeder Sorte einen Rohstoff als Material sammeln. Du benötigst Rohstoffe auch für Samurai und Shogune.</p>
              <p>Es gibt: Reis, Erz und Bambus.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-resources.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Samurai</h4>
              <p>Du brauchst sie für den Kampf um gegnerisches Material und um deines zu verteidigen.</p>
              <p>Es gibt: Lanzen-, Schwert- und Bogen-Samurai.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-fighters.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Shogune</h4>
              <p>Ein Shogun bringt dir Vorteile: du darfst mehr Samurai ausbilden und mehr Karten aufnehmen.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-booster.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Ninja</h4>
              <p>Er erscheint plötzlich, und hilft dem schwächsten Spieler.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-special.jpg" class="image-responsive mt-n3" />
            </div>
          </div>
          `,
        },
        {
          title: 'Spielaufbau',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">1. </span> Paläste und Ninja</h4>
              <p>
              Sammle alle 12 Paläste und den Ninja aus dem Spiel.
              </p>
              
              <hr />
              
              <h4><span class="typo-highlight">2. </span> Palastbau</h4>
              <p>
              <strong>2-4 Spieler:</strong> Jeder Spieler erhält <strong>3</strong> Paläste ...
              <br>
              <strong>5-6 Spieler:</strong> Jeder Spieler erhält <strong>2</strong> Paläste ...
              </p>
              <p>
                ... und legt diese verdeckt gestapelt als "Palastbau" vor sich.
              </p>
        
              <p>
              Die restlichen Paläste werden nicht mehr gebraucht. Leg sie zur Seite.
              </p>

            </div>
            
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-prepare-a.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
                Alle Paläste und den Ninja aussortieren
              </p>
              <img src="/images/tricto-rules-prepare-b.jpg" class="image-responsive mt-6" />
              <p class="typo-note">
                Lege den "Palastbau" vor dir hin
              </p>
            </div>
            
            <div class="col-12 col-sm-6 my-n3">
              <hr />
            </div>

            <div class="col-12 col-sm-6 my-n3">
            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">3. </span> Ziehstapel bereitlegen</h4>
                <p>
                Die anderen Karten werden jetzt möglichst gut gemischt und in der Mitte als "Ziehstapel" bereit gelegt.
                </p>
                
                <hr />

              <h4><span class="typo-highlight">4. </span> 3 Karten auf den Markt</h4>
              <p>
              3 Karten werden als "Markt" vom Ziehstapel offen in die Mitte gelegt.
              </p>
              
              <hr />

                <h4><span class="typo-highlight">5. </span> Ablage</h4>
                <p>
                Aus abgelegten Karten bildet sich später eine "Ablage". Ist der Ziehstapel leer, wird die Ablage gemischt und erneut als Ziehstapel verwendet.
                </p>
              </div>
            
              <div class="col-12 col-sm-6">
                <img src="/images/tricto-rules-prepare-c.jpg" class="image-responsive mt-n3" />
                <p class="typo-note">
                Leg den Markt und den Ziehstapel in die Mitte des Spiels
                </p>
              </div>
              
              <div class="col-12 col-sm-6 my-n3">
                <hr />
              </div>

              <div class="col-12 col-sm-6 my-n3">
              
              </div>


            <div class="col-12 col-sm-6">


              
              <h4><span class="typo-highlight">6.</span> 6 Karten auf die Hand</h4>
              <p>
              Jeder Spieler bekommt vom Ziehstapel verdeckt 6&nbsp;Karten auf die Hand.
              </p>
              
              <hr />

              <h4><span class="typo-highlight">7.</span> Ninja</h4>
              <p>
              Mische jetzt den Ninja unter den Ziehstapel.
              </p>
              
              <hr />

              <h4><span class="typo-highlight">8.</span> Wer fängt an?</h4>
              <p>
              Das entscheidet der Besitzer des Spiels. Würfeln oder Streichholz 
ziehen? Egal, sei kreativ.
              </p>
              
              </div>
            
              <div class="col-12 col-sm-6">
                <img src="/images/tricto-rules-prepare-d.jpg" class="image-responsive mt-n3" />
                <p class="typo-note">
                Deine 6 Hand-Karten hältst du auf der Hand 
                </p>
              </div>

          

          </div>
          
          `,
        },
      ],
    },

    // Game turn
    {
      title: 'Spielzug',
      body: `
      <p>Während deines Spielzugs kannst du verschiedene Aktionen in beliebiger Reihenfolge ausführen (du musst es aber nicht). Danach beendest du deinen Spielzug mit dem Aufnehmen von Karten.
      </p>
      <p>Das Spiel geht reihum im Uhrzeigersinn.</p>
      `,
      lastDark: true,
      classes: 'bg-red',
      chapters: [
        {
          title: 'Karten tauschen',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              Für deine Aktionen brauchst du die richtigen Karten auf der Hand. Dazu kannst du Karten <strong>1:1</strong> von deiner Hand mit dem Markt und mit Mitspielern tauschen.
              </p>
              <p>Ja, 1&nbsp;Rohstoff darf auch gegen 1&nbsp;Samurai oder 1&nbsp;Shogun getauscht werden und umgekehrt.</p>
            </div>

            <div class="col-12 col-sm-6">
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>Auf dem Markt tauschen</h3>
              
              <p>Pro Spielzug <strong>darfst</strong> du den Markt einmalig durch 3&nbsp;neue Karten vom Ziehstapel ersetzen.
              Das ist optional, du kannst ihn auch einfach akzeptieren.</p>

              <p><strong>Danach</strong> darfst du Karten <strong>1:1</strong> zwischen deiner Hand und dem Markt tauschen. Solange du dran bist, zu jeder Zeit und so oft du willst.</p>

            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-change-a.jpg" class="image-responsive mt-n3" />
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>Mit Mitspielern tauschen</h3>
              
              <p>Gelingt es dir, einen Mitspieler zu überzeugen, dann könnt ihr Karten auch 1:1 von Hand zu Hand tauschen.</p>

              <div class="rules__hint">
                <p>
                <strong>TIPP Mitspieler überreden</strong><br/>
                Überzeuge mit Politik. Z.B.: "Tausch mit mir, sonst greife ich dich an.", oder "Hilf mir, sonst hat der/die da gleich gewonnen."
                </p>
              </div>
              
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-change-b.jpg" class="image-responsive mt-n3" />
            </div>

          </div>
          `,
        },
        {
          title: 'Samurai ausbilden',
          body: `
          
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
                Für die Verteidgung deiner gesammelten Materialien brauchst du kampfbereite Samurai. Natürlich auch, um selbst einen Angriff zu starten.
              </p>
              <p>
              Nur wenn du 1 Samurai und 2 Rohstoffe in <strong>gleicher Farbe</strong> auf der Hand hast, kannst du den Samurai ausbilden. 
              </p>
              <p>Lege die zwei Rohstoffe auf die Ablage und den Samurai offen vor dich.</p>
              <div class="rules__hint">
                <p> <strong>Farbenblind? </strong><br/>
                Die 2 Icons in weiß zeigen dir den passenden Rohstoff auf jeder Samurai-Karte:</p>
                <img src="/images/tricto-rules-buy-fighter-d.jpg" class="image-responsive mt-n3" />
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-buy-fighter-a.jpg" class="image-responsive mt-n3" />
              <img src="/images/tricto-rules-buy-fighter-b.jpg" class="image-responsive mt-n3" />
              <img src="/images/tricto-rules-buy-fighter-c.jpg" class="image-responsive mt-n3" />
            </div>
            
            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>Max. 3 Samurai</h3>
              <p>
              Du darfst zu Beginn <strong>max.&nbsp;3</strong> Samurai ausbilden.
              </p>
              <p>
              Pro ernanntem Shogun erhöht sich diese maximale Anzahl um 1&nbsp;Samurai (Siehe "Shogun ernennen").
              </p>
              <h3>Kombination egal</h3>
              <p>
                Die Kombination deiner ausgebildeten Samurai ist egal.
                Du darfst auch mehrere Samurai gleicher Art ausbilden.
              </p>
              
            </div>

            <div class="col-12 col-sm-6">
            <img src="/images/tricto-rules-buy-fighter-e.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              <strong>BEISPIEL:</strong><br/>
              Ohne Shogune, darfst du max.&nbsp;3&nbsp;Samurai in beliebiger Kombination ausbilden.
              </p>
              
            </div>

          </div>
          
          `,
        },
        {
          title: 'Shogun ernennen',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
                Einen Shogun kannst du ernennen, sobald du ihn und die 3 benötigten Rohstoffe (Reis, Erz und Bambus) auf der Hand hast.
              </p>
              <p>
              Lege die 3 Rohstoffe auf die Ablage und den ernannten Shogun offen vor dich.
              </p>
              <p>Du kannst beliebig viele Shogune ernennen.</p>

              <h3>Was nützt dir ein Shogun?</h3>
              <p>
                <strong>1.</strong> du ziehst pro Shogun an jedem Spielzug-Ende eine Karte mehr
              </p>
              <p>
                <strong>2.</strong> du kannst pro Shogun 1&nbsp;Samurai mehr ausbilden
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-buy-booster-a.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
                3 Rohstoffe auf die Ablage,<br/>
                ernannter Shogun offen vor dich.
              </p>
              <img src="/images/tricto-rules-buy-booster-b.jpg" class="image-responsive" />
              <p class="typo-note">
              <strong>BEISPIEL:</strong> Hast du 3 Shogune,<br/>
              darfst du max. 6 Samurai ausbilden.
              </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Material erzeugen',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              Für den Bau eines Palasts brauchst du die 3&nbsp;Materialien: Erz, Reis und Bambus. 
              </p>
              <p>
              Pro Spielzug, kannst du dazu <strong>1&nbsp;</strong>beliebigen Rohstoff von deiner Hand auf deinen Palastbau legen (du musst nicht). 2 oder mehr Materialien der gleichen Art zu sammeln ist erlaubt.
              </p>

              <p>
              <strong>Achtung!</strong> Sobald du Material besitzt, bist du angreifbar (siehe "Angriff zum plündern").
              </p>
              
              <div class="rules__hint">
                <p>
                <strong>TIPP: </strong>Material erzeugen ist nur ratsam, wenn du ausgebildete Samurai zur Verteidigung hast. 
                </p>
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-resources.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              <strong>BEISPIEL:</strong><br/>
               1 Reis liegt auf den noch zu bauenden Palästen
              </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Angriff zum plündern',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
            <p>
            Pro Spielzug darfst du <strong>1 x angreifen</strong>, um 1&nbsp;Material bei einem Gegner zu erbeuten (zusätzlich zum Erzeugen von Material).
            </p>
            <h3>Wann darfst du angreifen?</h3>
            <p>
            Deine Samurai kämpfen nur für dich, wenn Material bei deinem Gegner als Beute lockt. Hat dein Gegner keine Samurai zur Verteidigung, hast du leichtes Spiel und kannst mit deiner Armee 1&nbsp;Material ohne Kampf erbeuten (zählt als Angriff).
            </p>
            </div>
            <div class="col-12 col-sm-6">

            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">1.</span> Armee aufstellen</h4>
              <p>
              Eine Armee besteht aus <strong>1 bis max. 3</strong> Samurai. Nur die Samurai einer Armee kämpfen (kein Nachziehen, Verstärken etc.)!
              </p>
              <p>
              Wähle für deinen Angriff also max. 3 deiner ausgebildeten Samurai und zeig sie allen. Danach wählt der Verteidiger auf gleiche Weise die Samurai für seine Armee.
              </p>

              <div class="rules__hint">
                <p>
                <strong>TIPP:</strong> Entscheide dich strategisch für die beste Kombination von Samurai, du kannst auch mehrere der gleichen Art wählen.
                </p>
              </div>
              <br />

              <p>
              Die größere Armee wird zuerst aufgestellt (sind beide gleich groß beginnt der Angreifer). Positioniere die Samurai <strong>verdeckt</strong> in eine Reihe, so dass nur du die Aufstellung kennst.
              </p>
              <p>
              Jetzt legt der andere Spieler jedem Samurai möglichst einen seiner Samurai verdeckt zum Duell entgegen.
              </p>
            </div>

            
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-a.jpg" class="image-responsive mt-n3" />
              <div class="rules__hint rules__hint--light">
                <p>
                <strong>BEISPIEL:</strong> <br/>
                <strong>A</strong> Größere Armee wird zuerst aufgestellt<br/>

                <strong>B</strong> Jedem Samurai wird möglichst einer entgegen gelegt
                </p>
              </div>
            </div>

            <div class="col-12">
              <hr />
            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">2.</span> Kämpfen</h4>
              <p>Deckt nun die Samurai auf, die sich zum Duell gegenüber liegen. Das Icon mit dem Pfeil oben rechts auf der Samurai-Karte, zeigt welchen anderen Samurai dieser schlägt. Geschlagene Samurai kommen auf die Ablage.</p>

              <p>Zwei gleiche Samurai schlagen sich gegenseitig.</p>

              <p>Sind alle Duelle ausgefochten, nehmt eure verbleibenden Samurai wieder auf und legt sie für ein weiteres Duell wieder hin (wie in Punkt 1 beschrieben).</p>

              <p>
              Das wiederholt ihr so lange, bis eine oder beide Armeen komplett zerstört sind.
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-b.jpg" class="image-responsive mt-n3" />
              <div class="rules__hint rules__hint--light">
                <p>
                <strong>BEISPIEL:</strong> <br/>
                <strong>a</strong> Lanze- schlägt Schwert-Samurai<br/>
                <strong>b</strong> Zwei gleiche schlagen sich gegenseitig<br/>
                <strong>c</strong> Samurai ohne Gegner bleibt verdeckt
                </p>
              </div>
            </div>

            <div class="col-12">
              <hr />
            </div>
            
            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-a.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Lanze schlägt Schwert
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-b.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Schwert schlägt Bogen
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-c.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Bogen schlägt Lanze
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-d.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Gleiche schlagen sich gegenseitig
              </p>
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">3.</span>  Material erbeuten</h4>
              <p>
              Hast du als Angreifer einen Sieg errungen oder eure Armeen wurden beide vernichtet, nimm vom Verteidiger als Beute <strong>1</strong>&nbsp;Material deiner Wahl und lege es auf deinen Palastbau. Nein, ein siegreicher Verteidiger bekommt keine Beute.
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-c.jpg" class="image-responsive mt-n3" />
              <div class="typo-note">
                <p>
                <strong>1</strong> beliebiges Material<br/>
                kommt auf den Palastbau des Angreifers
                </p>
              </div>
            </div>

            <div class="col-12 col-sm-6">
            <h4><span class="typo-highlight">4.</span>  Schutz nach einem Angriff</h4>
            <p>
            Wurdest du angegriffen, bist du für den Rest dieser Runde vor weiteren Angriffen geschützt (egal, wie der Kampf ausging). Als Zeichen dafür, lege deine übrigen Materialien unter deinen Palastbau. Sobald du das nächste mal dran bist, legst du sie wieder offen auf deinen Palastbau und bist angreifbar.
            </p>
          </div>

          <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-d.jpg" class="image-responsive mt-n3" />
              <div class="typo-note">
                <p>
                <strong>Schutzmodus:</strong><br/> Restliches Material kommt unter Palastbau
                </p>
              </div>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Palast bauen',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>Sobald du die 3 verschiedenen Materialien Reis, Erz und Bambus auf deinem Palastbau gesammelt hast, ist dein Palast fertig und du bist deinem Sieg näher gekommen.
              </p>
              <p>
              Lege die 3 Materialien auf die Ablage und decke 1&nbsp;Palast auf.</p>

              <div class="rules__hint">
                <p>
                <strong>ACHTUNG!</strong> Wir reden hier von Material das erzeugt oder erbeutet wurde. Rohstoffe von der Hand verwenden, zäht nicht. 
                </p>
              </div>

            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-build-objective.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
                Die 3 Materialien auf die Ablage legen <br/>
                und 1 Palast umdrehen
                </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Spielzug Ende',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              Du beendest deinen Spielzug, indem du vom Ziehstapel solange ziehst, bis du wieder 6&nbsp;Karten auf der Hand hast.
              </p>
              <p>
              Pro ernanntem <strong>Shogun</strong> bekommst du jetzt 1&nbsp;Karte mehr.
              </p>
              <p>
              Damit ist dein Zug vorbei, der/die nächste ist dran!
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="typo-note text-left">
              <strong>BEISPIEL:</strong> 
              Hast du 1 Shogun,<br/>
              darfst du auf 7 Karten auffüllen
              </p>
              <p class="typo-note text-left">
              <strong>BEISPIEL:</strong> 
              Hast du 3 Shogune,<br/>
              darfst du auf 9 Karten auffüllen
              </p>
            </div>

          </div>
          
          `,
        },
      ],
    },

    // Ninja
    {
      title: 'Der Ninja',
      classes: 'bg-night',
      body: `
      <p>Der Ninja erscheint unerwartet im Ziehstapel und kämpft für den schwächsten Spieler.</p>
      <p>Du hast den Ninja gezogen? Leg ihn sofort offen hin und zieh an seiner Stelle eine weitere Karte.</p>
      `,
      chapters: [
        {
          title: 'Ninja Attacke',
          body: `<div class="row">
          <div class="col-12 col-sm-6">
            <p>
            Der Ninja kämpft nur für den schwächsten Spieler.
            Du bist am schwächsten, sobald eine der Fragen zutrifft. 
            Nur wenn eine Frage auf mehrere Spieler zutrifft, geh zur nächsten:
            </p>
            <p>
           <strong>1.</strong> Du hast die wenigsten gebauten Paläste?
            </p>
            <p>
            <strong>2.</strong> Du hast die wenigsten Materialien?
            </p>
            <p>
            <strong>3.</strong> Du hast die wenigsten Shogune?
            </p>
            <p>
            <strong>4.</strong> Du hast die wenigsten Samurai?
            </p>
            <p>
            <strong>5.</strong> Du hast den Ninja gezogen?
            </p>

            <hr/>

            <h3>Der Ninja greift lautlos an</h3>
            <p>
            Du als schwächster Spieler entscheidest jetzt, wer das Opfer des Ninjas ist.
            </p>
            
            <p>
            Der Ninja stiehlt nun <strong>entweder</strong> 1 Material vom Opfer und bringt es auf deinen Palastbau (Schutzmodus wirkt hier nicht).
            </p>
            
            <p>
            <strong>Oder</strong> er meuchelt lautlos 1 Shogun des Opfers und lässt ihn auf der Ablage verschwinden (die zusätzlich ausgebildeten Samurai des Opfers bleiben). Die Entscheidung liegt bei dir.
            
            </p>

            <hr/>

            <h3>Der Ninja verschwindet wieder</h3>
            <p>
             Nimm den Ziehstapel und die Ablage zusammen mit dem Ninja. Mische diese Karten gut und leg sie als neuen Ziehstapel verdeckt bereit.
            </p>
            </div>
        
          <div class="col-10 col-sm-6">
            <div class="px-10">
            <img src="/images/tricto-rules-special-card.jpg" class="image-responsive mt-n3"/>
            </div>

          </div>
        
        </div>`,
        },
      ],
    },
  ],
  outro: {
    title: 'Spielende',
    body: `
    <div class="text-center">
    <p>
    Sobald du den 3. Palast errichtest, bist du der große Kaiser und hast das Spiel gewonnen.
    </p>
    <img class="pl-4" src="/images/tricto-rules-game-end-a.png" class="image-responsive mt-n3"  style="max-width: 320px"/>
    <p>
    <br/>
    Bei <strong>5 oder 6 Spielern</strong> gewinnst du schon mit deinem 2. Palast.
    </p>
    <img class="pl-4" src="/images/tricto-rules-game-end-b.png" class="image-responsive mt-n3" style="max-width: 320px" />
    <br />
    <br/>
    <p>
    Herzlichen Glückwunsch Stratege-San!
    <br/>
    Zeit für die nächste Runde. Oder hast du Angst vor einer Revanche?
    </p>
    </div>
    
    `,

    body2: `
      <h2 class="typo-hl-1">Vielen Dank fürs Spielen</h2>
      <p><strong>Wenn du Fragen oder Feedback hast, melde dich gern!</strong></p>

      <div class="row">
        <div class="col-12 col-sm-6">
          <a class="btn-icon" href="https://www.instagram.com/play.tricto/" target="_blank" title="Folge @play.tricto auf Intagram"><span class="btn-icon__icon btn-icon__icon--insta"></span><span class="btn-icon__text">Folge uns auf Instagram</span></a>
        </div>
        <div class="col-12 col-sm-6">
          <a class="btn-icon" href="mailto:info@playtricto.com"
          title="Screibe uns eine E-Mail" target="_blank"><span class="btn-icon__icon btn-icon__icon--mail" ></span> <span class="btn-icon__text">Schreibe uns eine Mail</span></a>
        </div>
      </div>
    `,
  },
};

export default rules;
